exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pr[data-v-1f821c2f] {\n  padding-right: 25px !important;\n}\n.pl[data-v-1f821c2f] {\n  padding-left: 25px !important;\n}\n.spacer[data-v-1f821c2f] {\n  margin: 30px 0 30px 0 !important;\n}\n", ""]);

// exports
